import React from 'react';
import { connect } from 'react-redux';
import { ResponsiveContainer, PieChart, Pie, Tooltip, Cell } from 'recharts';

import { orderByStatus } from '~/actions/orders';
import { listUsers } from '~/actions/user';

import Styles from './widget.scss';

const chartColors = [
  '#0095ff',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#8042ff',
  '#ffdf42',
  '#42c1ff',
  '#ff4262'
];

class BoxCountChart extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      detailedInfo: null,
      users: {}
    };
  }

  componentDidMount() {
    this.getOrders(this.props.indata.orderStatus);
  }

  componentWillReceiveProps(nextProps) {
    const { orderStatus } = nextProps.indata;
    if (orderStatus && this.props.indata.orderStatus !== orderStatus) {
      this.getOrders(orderStatus);
    }
  }

  getOrders(orderStatus) {
    orderByStatus(this.props.dispatch, this.context.apiClient, orderStatus);
    listUsers(this.props.dispatch, this.context.apiClient).then(res =>
      this.setState({
        users: res.data.reduce((obj, user) => {
          obj[user.userId] = user; // eslint-disable-line no-param-reassign
          return obj;
        }, {})
      })
    );
  }

  getStats(orders) {
    const out = {};
    // count all in todo
    out.orderCount = (orders && orders.length) || 0;
    out.boxes = 0;
    out.boxesInit = [];
    out.boxesBeingPicked = [];
    out.boxesPickPaused = [];
    out.boxesWaitQA = [];
    out.boxesBeingQA = [];
    out.boxesQAPaused = [];
    out.boxesWaitLabel = [];
    out.boxesBeingLabeled = [];
    out.boxesLabelPaused = [];
    out.boxesWaitShipped = [];
    orders.forEach(order => {
      // step boxes
      order.boxes.forEach(b => {
        out.boxes += 1;
        const box = { ...b, invoiceId: order.invoiceId, boxCount: order.boxes.length };
        switch (box.status) {
          case 'notstarted':
            out.boxesInit.push(box);
            break;
          case 'pickStart':
            out.boxesBeingPicked.push(box);
            break;
          case 'pickPause':
            out.boxesPickPaused.push(box);
            break;
          case 'pickStop':
            out.boxesWaitQA.push(box);
            break;
          case 'qaStart':
            out.boxesBeingQA.push(box);
            break;
          case 'qaPause':
            out.boxesQAPaused.push(box);
            break;
          case 'qaStop':
            out.boxesWaitLabel.push(box);
            break;
          case 'shippedStart':
            out.boxesBeingLabeled.push(box);
            break;
          case 'shippedPause':
            out.boxesLabelPaused.push(box);
            break;
          case 'shippedStop':
            out.boxesWaitShipped.push(box);
            break;
          default:
            break;
        }
      });
    });
    return out;
  }

  getChartInfo(info) {
    return [
      {
        name: 'Boxes not started',
        value: info.boxesInit.length,
        boxes: info.boxesInit
      },
      {
        name: 'Boxes being picked',
        value: info.boxesBeingPicked.length,
        boxes: info.boxesBeingPicked
      },
      {
        name: 'Paused picking',
        value: info.boxesPickPaused.length,
        boxes: info.boxesPickPaused
      },
      {
        name: 'Waiting for QA',
        value: info.boxesWaitQA.length,
        boxes: info.boxesWaitQA
      },
      {
        name: 'Boxes being QA',
        value: info.boxesBeingQA.length,
        boxes: info.boxesBeingQA
      },
      {
        name: 'QA paused',
        value: info.boxesQAPaused.length,
        boxes: info.boxesQAPaused
      },
      {
        name: 'Waiting for label',
        value: info.boxesWaitLabel.length,
        boxes: info.boxesWaitLabel
      },
      {
        name: 'Paused labeling',
        value: info.boxesLabelPaused.length,
        boxes: info.boxesLabelPaused
      },
      {
        name: 'Boxes being labeled',
        value: info.boxesBeingLabeled.length,
        boxes: info.boxesBeingLabeled
      }
      // {
      //   name: 'Waiting for shipping',
      //   value: info.boxesWaitShipped.length,
      //   boxes: info.boxesWaitShipped
      // }
    ].map((c, i) => {
      return { ...c, fill: chartColors[i % chartColors.length] };
    });
  }

  selectDetailedInfo(name) {
    const { detailedInfo } = this.state;
    this.setState({ detailedInfo: name === detailedInfo ? null : name });
  }

  render() {
    if (!this.props.orders) {
      return <div>Loading...</div>;
    }
    const { users, detailedInfo } = this.state;
    const info = this.getStats(this.props.orders);
    const chartInfo = this.getChartInfo(info);
    const selectedChartInfo = chartInfo.find(c => c.name === detailedInfo);
    return (
      <div className={this.props.className}>
        <div className={Styles.countChartInfo}>
          <h5 className={Styles.title}>{this.props.indata.title}</h5>
          <div>Orders: {info.orderCount}</div>
          <div>Boxes: {info.boxes}</div>
          <hr />
          {chartInfo.map(entry => {
            const selected = entry === selectedChartInfo;
            return (
              <div
                key={entry.name}
                onClick={() => this.selectDetailedInfo(entry.name)}
                className={`${Styles.chartInfo} ${selected && Styles.chartInfoSelected}`}
              >
                <span className={Styles.chartInfoFill} style={{ backgroundColor: entry.fill }} />
                {entry.name}: {entry.value}
              </div>
            );
          })}
        </div>
        <ResponsiveContainer minHeight={200} width="50%" className={Styles.countChart}>
          <PieChart margin={{ left: 20, right: 20, top: 20, bottom: 20 }}>
            <Pie isAnimationActive={false} data={chartInfo} label dataKey="value">
              {chartInfo.map(entry => <Cell key={entry} fill={entry.fill} />)}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
        <div className="clear" />
        {selectedChartInfo && (
          <div className={Styles.selectedChartInfo}>
            <span className={Styles.title}>{selectedChartInfo.name}</span>
            <table>
              <tbody>
                {selectedChartInfo.boxes.map(b => {
                  const user = users[b.currentUser] || { name: '' };
                  return (
                    <tr key={`box_${b.invoiceId}_${b.boxVis}`}>
                      <td className={Styles.invoiceId}>{b.invoiceId}</td>
                      <td className={Styles.boxUser}>{user.name}</td>
                      <td className={Styles.boxCount}>
                        Box {b.boxVis} / {b.boxCount}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, { indata }) => {
  const orders = state.getIn(['orders', 'tabData', indata.orderStatus, 'orders'], false);
  return {
    orders: orders && orders.toJS()
  };
};

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(BoxCountChart);



// WEBPACK FOOTER //
// ./app/widgets/BoxCountChart/widget.js